import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from '@/hooks/use-toast';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute = ({
  children,
  redirectTo = '/sign-in',
}: ProtectedRouteProps) => {
  const { isSignedIn, isLoaded, loading } = useAuth();

  useEffect(() => {
    if (isLoaded && !isSignedIn && !loading) {
      toast({
        title: 'Access Denied',
        description: 'Please sign in to access this page',
        variant: 'destructive',
      });
    }
  }, [isLoaded, isSignedIn, loading]);

  if (!isLoaded || loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export const AuthLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-hero">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary mb-4 mx-auto"></div>
        <p className="text-primary animate-pulse">Loading authentication...</p>
      </div>
    </div>
  );
};